<template>
  <div class="recharge-page">
    <van-nav-bar
      title="会员充值"
      left-arrow
      @click-left="goHome"
      fixed
    />

    <div class="content">
      <div class="benefits">
        <h3 class="benefits-title">会员特权</h3>
        <div class="benefit-item">
          <van-icon name="checked" size="16" color="#1989fa" />
          <span>内部资源无限次获取</span>
        </div>
        <div class="benefit-item">
          <van-icon name="checked" size="16" color="#1989fa" />
          <span>高速下载通道</span>
        </div>
      </div>

      <div class="price-cards">
        <div class="price-card" :class="{ active: selectedPlan === 'month' }" @click="selectedPlan = 'month'">
          <div class="plan-name">{{ planConfig.month.label }}会员</div>
          <div class="price">
            <span class="currency">¥</span>
            <span class="amount">{{ planConfig.month.price }}</span>
          </div>
          <div class="plan-desc">{{ planConfig.month.desc }}</div>
          <div class="check-icon" v-if="selectedPlan === 'month'">
            <van-icon name="checked" size="20" color="#fff" />
          </div>
        </div>

        <div class="price-card" :class="{ active: selectedPlan === 'year' }" @click="selectedPlan = 'year'">
          <div class="plan-tag">推荐</div>
          <div class="plan-name">{{ planConfig.year.label }}会员</div>
          <div class="price">
            <span class="currency">¥</span>
            <span class="amount">{{ planConfig.year.price }}</span>
          </div>
          <div class="plan-desc">{{ planConfig.year.desc }}</div>
          <div class="check-icon" v-if="selectedPlan === 'year'">
            <van-icon name="checked" size="20" color="#fff" />
          </div>
        </div>
      </div>

      <div class="pay-info">
        <div class="pay-row">
          <span class="label">支付方式：</span>
          <span class="value">支付宝支付</span>
        </div>
        <div class="pay-row">
          <span class="label">充值账号：</span>
          <span class="value">{{ userInfo.userName }}</span>
        </div>
      </div>

      <van-button
        type="primary"
        block
        round
        class="submit-btn"
        @click="handlePay"
      >
        立即支付
      </van-button>

      <div class="tip">
        <van-icon name="info-o" size="14" />
        <span>支付成功后自动开通会员</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Recharge',
  data() {
    return {
      selectedPlan: 'month',
      userInfo: {
        userName: ''
      },
      planConfig: {
        month: { price: 5, vipDay: 30, label: '包月', desc: '平均每天 0.17 元' },
        year: { price: 19.9, vipDay: 365, label: '包年', desc: '平均每天 0.05 元' }
      }
    };
  },
  mounted() {
    this.loadUserInfo();
  },
  methods: {
    loadUserInfo() {
      const userinfo = localStorage.getItem('userinfo');
      if (userinfo) {
        try {
          const parsed = JSON.parse(userinfo);
          if (parsed && parsed.data) {
            this.userInfo = parsed.data;
          }
        } catch (e) {
          console.error('Parse userinfo error:', e);
        }
      }
    },
    goHome() {
      this.$router.push('/');
    },
    async handlePay() {
      const userinfo = localStorage.getItem('userinfo');
      if (!userinfo) {
        this.$toast('请先登录');
        setTimeout(() => {
          this.$router.push('/login');
        }, 500);
        return;
      }

      try {
        const parsed = JSON.parse(userinfo);
        const userId = parsed.data.id;
        
        const selectedConfig = this.planConfig[this.selectedPlan];
        const planName = selectedConfig.label;
        
        const baseUrl = 'https://www.leodyzy.top/video/startpay';
        const params = new URLSearchParams({
          payType: 'alipay-facetoface',
          returnUrl: 'https://www.wpan.top',
          price: selectedConfig.price,
          userId: userId,
          vipDay: selectedConfig.vipDay,
          fromType: '5'
        });
        
        const payUrl = `${baseUrl}?${params.toString()}`;
        try {
          const response = await fetch(payUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });
          
          const result = await response.json();
          
          if (result.success && result.data && result.data.payUrl) {
            window.location.href = result.data.payUrl;
          } else {
            this.$toast(result.msg || '获取支付链接失败');
          }
        } catch (error) {
          console.error('Get payUrl error:', error);
          this.$toast('获取支付链接失败');
        }
      } catch (error) {
        console.error('Parse userinfo error:', error);
        this.$toast('获取用户信息失败');
      }
    },
    goToProfile() {
      this.$router.push('/profile');
    }
  }
};
</script>

<style scoped>
.recharge-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 46px;
  padding-bottom: 50px;
}

.content {
  padding: 16px;
}

.benefits {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.benefits-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.benefit-item:last-child {
  margin-bottom: 0;
}

.price-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 16px;
}

.price-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  text-align: center;
  cursor: pointer;
  position: relative;
  border: 2px solid #ebedf0;
  transition: all 0.3s;
}

.price-card.active {
  border-color: #1989fa;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}

.price-card .plan-tag {
  position: absolute;
  top: -8px;
  right: 12px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a6f);
  color: #fff;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
}

.plan-name {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 12px;
}

.price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-bottom: 8px;
}

.currency {
  font-size: 16px;
  font-weight: 600;
}

.amount {
  font-size: 32px;
  font-weight: 700;
}

.plan-desc {
  font-size: 12px;
  opacity: 0.8;
}

.price-card.active .plan-desc {
  opacity: 1;
}

.check-icon {
  position: absolute;
  top: 12px;
  left: 12px;
}

.pay-info {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.pay-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.pay-row:last-child {
  margin-bottom: 0;
}

.pay-row .label {
  font-size: 14px;
  color: #999;
}

.pay-row .value {
  font-size: 14px;
  color: #333;
}

.submit-btn {
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.tip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12px;
  color: #999;
}
</style>
